import { Task } from "@/api.types";

export const getTaskTypeDisplay = (type: Task["type"]) => {
  const typeMap: Record<Task["type"], string> = {
    PICKUP: "Pick up",
    DELIVERY: "Delivery",
    DEPOT_RECEIVE: "Depot Receive",
    DEPOT_SORT: "Depot Sort",
    DEPOT_DISPATCH: "Depot Dispatch",
    RETURN: "Return",
  };
  return typeMap[type] || type;
};
